/**
 * VIP Variant Handler
 * Handles showing/hiding VIP registration link based on selected variant
 */
class VipVariantHandler {
  constructor() {
    this.vipNotice = document.querySelector('[data-vip-restock-notice]');
    this.vipVariantData = this.getVipVariantData();
    this.buttonsWrapper = document.querySelector('[data-buttons-wrapper]');
    this.submitButtons = document.querySelector('.product__submit__buttons');
    
    if (this.vipNotice && this.vipVariantData) {
      this.init();
    }
  }
  
  init() {
    // Listen for variant changes
    document.addEventListener('variant:change', (event) => {
      this.handleVariantChange(event.detail.variant);
    });
    
    // Check initial variant state when page loads
    this.checkInitialVariant();
    
    // Listen for changes to the variant selector inputs
    const variantInputs = document.querySelectorAll('input[name="id"], select[name="id"]');
    variantInputs.forEach(input => {
      input.addEventListener('change', (e) => {
        this.updateVipVisibility(e.target.value);
      });
    });
    
    // Listen for option changes that trigger variant updates
    const optionInputs = document.querySelectorAll('[data-single-option-selector]');
    optionInputs.forEach(input => {
      input.addEventListener('change', () => {
        // Small delay to allow variant ID to update
        setTimeout(() => {
          const variantInput = document.querySelector('input[name="id"]');
          if (variantInput && variantInput.value) {
            this.updateVipVisibility(variantInput.value);
          }
        }, 50);
      });
    });
  }
  
  getVipVariantData() {
    const dataScript = document.querySelector('[data-vip-variant-data]');
    if (dataScript) {
      try {
        return JSON.parse(dataScript.textContent);
      } catch (e) {
        console.error('Error parsing VIP variant data:', e);
        return null;
      }
    }
    return null;
  }
  
  checkInitialVariant() {
    // Check if there's an initial variant selected
    const productForm = document.querySelector('[data-product-form]');
    if (productForm) {
      const variantInput = productForm.querySelector('input[name="id"]');
      if (variantInput && variantInput.value) {
        this.updateVipVisibility(variantInput.value);
      }
    }
  }
  
  handleVariantChange(variant) {
    if (variant && variant.id) {
      this.updateVipVisibility(variant.id);
    }
  }
  
  updateVipVisibility(variantId) {
    if (!this.vipVariantData || !variantId) {
      this.hideVipNotice();
      this.updateButtonSpacing(true); // Available variant
      return;
    }
    
    const variantData = this.vipVariantData[variantId];
    
    if (variantData && variantData.vip_eligible && !variantData.available) {
      this.showVipNotice();
      this.updateButtonSpacing(false); // Sold out variant
    } else {
      this.hideVipNotice();
      this.updateButtonSpacing(variantData ? variantData.available : true);
    }
  }
  
  showVipNotice() {
    if (this.vipNotice) {
      this.vipNotice.style.display = 'block';
    }
  }
  
  hideVipNotice() {
    if (this.vipNotice) {
      this.vipNotice.style.display = 'none';
    }
  }
  
  updateButtonSpacing(isAvailable) {
    // Add/remove classes to control button spacing when sold out
    if (this.buttonsWrapper) {
      if (isAvailable) {
        this.buttonsWrapper.classList.remove('buttons--sold-out');
      } else {
        this.buttonsWrapper.classList.add('buttons--sold-out');
      }
    }
    
    if (this.submitButtons) {
      if (isAvailable) {
        this.submitButtons.classList.remove('product__submit__buttons--sold-out');
      } else {
        this.submitButtons.classList.add('product__submit__buttons--sold-out');
      }
    }
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  new VipVariantHandler();
});